export enum ricHandleStatus {
  STARTED = 'started',
  PENDING = 'pending',
  RUNNING = 'running',
  ENDED = 'ended',
  FAILED = 'failed'
}
